/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

export type TypeAddCart = 'new' | 'update';

@Injectable({
  providedIn: 'root'
})
export class CartSaleService {
  data: any;
  data$: BehaviorSubject<any[]>;
  constructor() {
    this.data = {};
    this.data$ = new BehaviorSubject<any[]>(Object.values(this.data));
  }

  getData(): any[] {
    return Object.values(this.data);
  }
  getData$(): Observable<any[]> {
    return this.data$.asObservable();
  }
  setData$() {
    this.data$.next(this.getData());
  }
  addItem(itemFromSidebar) {
    const id = itemFromSidebar.selectedParent.id;

    if (this.data[id] === undefined) {
      this.data[id] = {
        ...itemFromSidebar.selectedParent
      };
    }

    if (this.data[id]['formatsSelled'] === undefined) {
      this.data[id]['formatsSelled'] = {};
    }

    const netPriceItem =
      itemFromSidebar.selectedChild.precio *
      itemFromSidebar.selectedChild.quantityInCart;

    this.data[id]['formatsSelled'][itemFromSidebar.selectedChild.format] = {
      format: itemFromSidebar.selectedChild.format,
      stock: itemFromSidebar.selectedChild.stock,
      precio: itemFromSidebar.selectedChild.precio,
      quantityInCart: itemFromSidebar.selectedChild.quantityInCart,
      netPrice: netPriceItem,
      subFormat: itemFromSidebar.selectedChild.subFormat,
      quantitySubFormat: itemFromSidebar.selectedChild.quantitySubFormat,
      profitMargin: itemFromSidebar.selectedChild.profitMargin,
      purchasePrice: itemFromSidebar.selectedChild.purchasePrice
    };

    this.setData$();
  }

  updateItem(itemFromSidebar) {
    const id = itemFromSidebar.selectedParent.id;
    const formatChosen = itemFromSidebar.selectedChild.format;

    this.data[id]['formatsSelled'][formatChosen]['quantityInCart'] =
      itemFromSidebar.selectedChild.quantityInCart;
    this.data[id]['formatsSelled'][formatChosen]['netPrice'] =
      itemFromSidebar.selectedChild.quantityInCart *
      itemFromSidebar.selectedChild.precio;

    this.setData$();
  }

  itemExistsInCart(itemFromSidebar) {
    const id = itemFromSidebar.selectedParent.id;
    const formatChosen = itemFromSidebar.selectedChild.format;
    const itemExists =
      id !== undefined &&
      this.data[id] !== undefined &&
      this.data[id]['formatsSelled'] !== undefined &&
      this.data[id]['formatsSelled'][formatChosen] !== undefined;

    return itemExists;
  }

  removeItem(itemFromExpansionTable) {
    const id = itemFromExpansionTable.selectedParent.id;
    const formatChosen = itemFromExpansionTable.selectedChild['format'];

    delete this.data[id]['formatsSelled'][formatChosen];

    if (Object.keys(this.data[id]['formatsSelled']).length === 0) {
      delete this.data[id];
    }

    this.setData$();
  }

  getTotalAmount(): number {
    let total = 0;
    Object.values(this.data).forEach((item: any) => {
      const itemsFormat = Object.values(item['formatsSelled']);

      itemsFormat.map((itemFormat) => {
        total += itemFormat['netPrice'];
      });
    });
    return total;
  }

  isCartEmpty() {
    return Object.keys(this.data).length === 0;
  }

  getBranchStoreIdOfProducts() {
    const productsValues = Object.values(this.data) as any[];
    return productsValues[0].selectedParent.branchStoreId;
  }

  emptyData() {
    this.data = {};
    this.data$.next(Object.values(this.data));
  }
}
